<template>
	<div class="search">
		<div style="padding: 15px 0px 17px 0px">
			<!-- <span>{{ isAll }}</span> -->
			<!-- 网址切换 -->
			<div class="websiteUrl-box">
				<skydropdown-select :options="typeList" @change="typeChange"
				:value="''"></skydropdown-select>
			</div>
			<span style="float: right">
				<!-- -->
				<span
					class="el-icon-setting setColor"
					@click="skip"
					v-if="getPermission('newConversationAssignment') && getPermission('liveChatNew')"
				></span>
				<el-popover placement="top" width="400" v-model="visible">
					<div class="tag-box">
						<div class="title">筛选</div>
						<choice v-model="checkChat" text="聊天"></choice>
						<choice v-model="checkInquiry" text="线索(非垃圾)"></choice>
						<choice v-model="checkCustomer" text="客户（非公海）"></choice>
						<choice v-model="checkRubbishInquiry" text="垃圾线索"></choice>
						<choice v-model="checkHighseasCustomer" text="公海客户"></choice>
						<el-row type="flex" :gutter="10" style="margin: 30px 13px 20px 13px">
							<el-col>
								<el-button style="width: 100%" @click="reset">重置</el-button>
							</el-col>
							<el-col>
								<el-button type="primary" style="width: 100%" @click="confim">确定</el-button>
							</el-col>
						</el-row>
					</div>

					<ig-icon
						:class="showCheck ? 'bluefont' : 'normalFont'"
						name="shaixuan"
						slot="reference"
					></ig-icon>
				</el-popover>
			</span>
		</div>
		<el-popover placement="bottom" width="330" v-model="visible1" :visible-arrow="false">
			<div class="search-popover">
				<!-- <el-scrollbar style="height: 100%" > -->
				<div v-if="input1">
					<div v-if="data && data.length > 0">
						<div class="title" v-if="chatData.length > 0">聊天</div>
						<list :data="chatData" @checkone="checkone" v-if="chatData.length > 0"></list>
						<div class="title" v-if="clueData.length > 0">线索</div>
						<list :data="clueData" @checkone="checkone" v-if="clueData.length > 0"></list>
						<div class="title" v-if="custData.length > 0">客户</div>
						<list :data="custData" @checkone="checkone" v-if="custData.length > 0"></list>
					</div>
					<div v-else class="nomsg">
						<ig-icon name="nomsg" style="font-size: 28px; color: #999999"></ig-icon>
						<div>没有找到相关结果</div>
					</div>
				</div>
				<div v-else class="no-data">请输入用户名称...</div>
				<!-- </el-scrollbar> -->
			</div>
			<el-input
				slot="reference"
				placeholder="搜索用户名称"
				prefix-icon="el-icon-search"
				size="mini"
				v-model="input1"
				clearable
				@input="changeInput"
				@focus="changeInput"
			></el-input>
		</el-popover>
		<!-- v-if="isAll == '全部对话'" -->
		<sky-tabs
			class="cust-tabs"
			v-model="tabValue"
			:tabList="tabList"
			@changeTab="confim"
		></sky-tabs>
	</div>
</template>
<script>
import skyTabs from '@/components/iglobalwin/formComponents/tabs/sky-tabs.vue';
import choice from '@/components/chat/components/choice.vue';
// import singleChoice from '@/components/chat/components/singleChoice.vue';
// import multipleChoice from '@/components/chat/components/multipleChoice.vue';
import list from '@/components/chat/components/list.vue';
import chatSer from '@/backend/services/chat/chatSer.js';
import { mapGetters } from 'vuex';
import skydropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';
export default {
	props: {
		// isAll: null,
		tabVal: null,
		dialogue: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			input1: '',
			state: '',
			visible1: false,
			visible: false,
			data: [],
			clueCheck: 1,
			custCheck: 1,
			followCheck: [],
			chatData: [],
			clueData: [],
			custData: [],
			searchTag: [
				{
					text: '聊天',
					value: 1,
				},
				{
					text: '线索（非垃圾）',
					value: 1,
				},
				{
					text: '客户（非公海）',
					value: 1,
				},
				{
					text: '垃圾线索',
					value: 1,
				},
				{
					text: '公海客户',
					value: 1,
				},
			],
			checkChat: false,
			checkCustomer: false,
			checkHighseasCustomer: false,
			checkRubbishInquiry: false,
			checkInquiry: false,
			checkType: false,
			showCheck: false,
			tabValue: '0',
			tabList: [
				{
					label: '待分配',
					name: '0',
				},
				{
					label: '已分配',
					name: '1',
				},
			],
			typeList: [
				{
					label: '全部渠道',
					value: '',
					style:{ paddingLeft: '20px' }
				},
				{
					label: 'Messenger',
					value: '1',
					icon: 'messenger'
				},
				{
					label: 'WhatsApp',
					value: '2',
					icon: 'whatsapp'
				},
			]
		};
	},
	filters: {
		toDealWith: function (value) {
			let { name, serviceCode } = value;
			if (name) return name;
			else return serviceCode;
		},
	},
	watch: {
		tabVal: {
			handler(val) {
				if (val) {
					this.tabValue = val ? '1' : '0';
				}
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		async selectWebsite(obj) {
			this.$store.commit('SET_ACTIVEWEBSITE', obj);
			sessionStorage.setItem("activeWebsiteId",obj.id);
		},
		skip() {
			this.$router.push({
				name: 'systemSetting',
				query: {
					tabs: 'newChatAssign',
				},
			});
		},
		checkTag(value) {
			this.checkChat = !value;
		},
		changeInput() {
			if (this.input1) {
				this.visible1 = true;
				this.getData();
			} else {
				this.visible1 = false;
				this.clueData = [];
				this.custData = [];
			}
			//请求方法data赋值
		},
		reset() {
			this.checkChat = false;
			this.checkCustomer = false;
			this.checkHighseasCustomer = false;
			this.checkRubbishInquiry = false;
			this.checkInquiry = false;
		},
		confim() {
			if (
				this.checkChat ||
				this.checkInquiry ||
				this.checkCustomer ||
				this.checkRubbishInquiry ||
				this.checkHighseasCustomer
			) {
				this.showCheck = true;
			} else {
				this.showCheck = false;
			}
			let assignmentFlag = this.tabValue == '1' ? true : false;
			this.$emit(
				'filter',
				this.checkChat,
				this.checkCustomer,
				this.checkHighseasCustomer,
				this.checkRubbishInquiry,
				this.checkInquiry,
				assignmentFlag
			);
			this.visible = false;
		},
		checkone(item) {
			this.visible1 = false;
			this.$emit('search', item);
		},
		async getData() {
			let param = {
				dialogue: this.dialogue ? 1 : 0, //对话(0,我的对话;1,全部对话)
				displayLength: 100,
				displayStart: 1,
				name: this.input1,
				checkChat: this.checkChat ? 1 : 0,
				checkCustomer: this.checkCustomer ? 1 : 0,
				checkHighseasCustomer: this.checkHighseasCustomer ? 1 : 0,
				checkRubbishInquiry: this.checkRubbishInquiry ? 1 : 0,
				checkInquiry: this.checkInquiry ? 1 : 0,
				checkType: 1, //是否查看全部数据类型(0:未读;1:是;)
				assignmentFlag: this.tabVal ? 1 : 0, //是否分配(0,否;1,是)
			};
			let res = await chatSer.chatList(param);
			this.data = res.data.data;
			this.chatData = this.data.filter(item => {
				return item.type == 0;
			});
			this.clueData = this.data.filter(item => {
				return item.type == 1;
			});
			this.custData = this.data.filter(item => {
				return item.type == 2;
			});
		},
		typeChange(val) {
			this.$emit('typeChange', val);
		},
	},
	computed: {
		...mapGetters(['webList','activeWebsite']),
		websiteUrl () {
			let { activeWebsite } = this;
			let { name } = activeWebsite;
			if (name) return activeWebsite && activeWebsite.name;
			else return activeWebsite && activeWebsite.serviceCode;
        },
	},
	components: {
		// singleChoice,
		// multipleChoice,
		list,
		choice,
		skyTabs,
		skydropdownSelect
	},
	mounted() {},
};
</script>
<style lang="scss" scoped>

.bluefont {
	color: #409eff;
	font-size: 14px;
	cursor: pointer;
}
.normalFont {
	color: #999999;
	font-size: 14px;
	cursor: pointer;
}
.setColor {
	color: #999999;
	font-size: 16px;
	cursor: pointer;
	margin-right: 15px;
}
.my-autocomplete {
	width: 270px;
	// border: 1px red solid;
}
.search {
	min-height: 90px;
	padding: 0px 15px;
	border-right: 1px #e8e8e8 solid;
	border-bottom: 1px #e8e8e8 solid;
	::v-deep .el-input__inner {
		border: unset;
		border-radius: 25px;
		background: #eeeeee;
	}
	.title {
		margin: 20px 0px;
	}
}
.tag-box {
	padding: 5px;
}
.title {
	margin: 10px 0px;
}
.no-data {
	text-align: center;
	font-size: 12px;
}
.search-popover {
	max-height: 500px;
	overflow-y: auto;
	overflow-x: hidden;
	// 改变滚动条样式
	&::-webkit-scrollbar {
		width: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #d8d8d8;
		border-radius: 6px;
	}

	&::-webkit-scrollbar-track {
		background-color: #fff;
		border-radius: 2px;
	}
}
.nomsg {
	padding: 20px;
	text-align: center;
	color: #999999;
	font-size: 12px;
}
.websiteUrl-box
{
	display: inline-block;
}
</style>
